<div class="blockering-sida-container">
  <div class="blockering-sida-content">
    <lib-icon [name]="titleIcon()" class="title-icon" />
    <h3>{{ title() }}</h3>
    <p [innerHTML]="description()"></p>
    @if (link(); as link) {
      <span class="link-container">
        <a vinnova-button-link class="link" [href]="link.url">
          {{ link.title }}
          <lib-icon name="chevron-right" class="icon-chevron" />
        </a>
      </span>
    }
  </div>
</div>
